import { isEmpty } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { DYNAMICQUERY } from '../../../../Utils/UtilFunctions/constant'
import { getSeedValues } from '../../../../Utils/UtilFunctions/useCaseUtilFunctions'
import Status from './Status'
import { LandingPageContext } from './UtilitiesLandingPage'

function AssetStatusIndicator(props: any) {
	const { asset, tag, tagData } = props
	const contextProps: any = React.useContext(LandingPageContext)
	const seedsList = useSelector((state: any) => state.seedsList)

	const dynamicQuery: any =
		getSeedValues(
			seedsList,
			DYNAMICQUERY,
			'Utilities CBM',
			contextProps.defaultPlantCode
		).length === 0
			? getSeedValues(seedsList, DYNAMICQUERY, 'Utilities CBM', 'HOU')
			: getSeedValues(
					seedsList,
					DYNAMICQUERY,
					'Utilities CBM',
					contextProps.defaultPlantCode
			  )

	const cubeTag =
		dynamicQuery !== undefined &&
		dynamicQuery.assetTags?.find((data: any) => {
			return data.asset === props.asset?.asset_name
		}) === undefined
			? dynamicQuery.assetTags?.find((data: any) => {
					return data.asset === 'others'
			  })
			: dynamicQuery.assetTags?.find((data: any) => {
					return data.asset === props.asset?.asset_name
			  })

	const cubeName: any = contextProps.correspondingCubes.find((cube: any) => {
		return (
			cube.name.includes('LastValueAgg') && !cube.name.includes('Actionable')
		)
	})?.name

	const cubeRecord = tagData.find((tagData: any) =>
		tagData[`${cubeName}.tagName`].includes(tag[0])
	)

	const cubeValue: any = cubeRecord ? cubeRecord[`${cubeName}.lastValue`] : null

	// console.log({
	// 	tagData,
	// 	tag,
	// 	uniqueTags,
	// 	tagValue: tagData.find((tagData: any) =>
	// 		tagData['ABQLastValueAgg.tagName'].includes(tag[0])
	// 	),
	// 	cubeValue:
	// 		Number(parseFloat(cubeValue).toFixed(2)) >= 1
	// 			? cubeTag.value['1']
	// 			: Number(parseFloat(cubeValue).toFixed(2)) <= 0
	// 			? cubeTag.value['0']
	// 			: 'intermediate'
	// })

	if (isEmpty(dynamicQuery)) return null

	return cubeValue !== null ? (
		<Status
			value={
				Number(parseFloat(cubeValue)?.toFixed(2)) >= 1
					? cubeTag?.value['1']
					: Number(parseFloat(cubeValue)?.toFixed(2)) <= 0
					? cubeTag?.value['0']
					: 'intermediate'
			}
			asset={asset}
		/>
	) : (
		<Status value={'nostatus'} asset={asset} />
	)
}

export default AssetStatusIndicator
